(function () {
  'use strict';

  // ── Cart add ─────────────────────────────────────────────────────────────────

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = '…';

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);

    fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function () {
        btn.textContent = '✓';
        setTimeout(function () {
          btn.textContent = '+';
          btn.disabled = false;
        }, 1800);
        // cart_drawer.js intercepts /cart/add.js and opens the drawer automatically
      })
      .catch(function () {
        btn.textContent = '!';
        setTimeout(function () {
          btn.textContent = '+';
          btn.disabled = false;
        }, 1800);
      });
  }

  // ── Init ─────────────────────────────────────────────────────────────────────

  function init() {
    var cards = document.querySelectorAll('.inner_products_itms.meta-rel-prods');
    if (!cards.length) return;

    cards.forEach(function (card) {
      var variantId = card.getAttribute('data-variant-id');
      var available = card.getAttribute('data-available') !== 'false';
      var btn = card.querySelector('.addon-quick-add');

      if (!btn || !variantId) return;

      if (!available) {
        btn.textContent = '—';
        btn.disabled = true;
        btn.classList.add('sold-out');
        return;
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(variantId, btn);
      });
    });

    // Reinitialise slick carousel — 2.5 slides so the 3rd peeks in (signals scrollability)
    var $slider = jQuery('.upslider_init');
    if (!$slider.length) return;

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      responsive: [
        { breakpoint: 640, settings: { slidesToShow: 1.4 } }
      ]
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
